<template>
	<div class="toggle" @click="check">
		<v-dialog
			v-model="modal"
			width="500"
		>
			<div class="are-you-sure">
				<span class="the-title">Sei sicuro?</span>
				<div class="buttons">
					<div @click="$router.push('/')">Esci dal gioco</div>
					<div @click="modal = false">Continua a giocare</div>
				</div>
			</div>
		</v-dialog>
		<v-icon color="white">mdi-emoticon-cry</v-icon>
	</div>
</template>

<script>
export default {
	data() {
		return {
			modal: false
		}
	},
	methods: {
		check() {
			this.modal = true;
		}
	},
	watch: {
		modal(value) {
			if(value) {
				this.playAudio('sad',true);
			}
			else {
				this.$store.state.sounds['sad'].pause()
			}
		}
	}
}
</script>
<style scoped lang="scss">
	.toggle {
		position: fixed;
		bottom: px(20);
		left: px(20);
		border-radius: 100%;
		background: $mondadori-blue;
		z-index: 999999;
		display: inline-block;
		cursor: pointer;
		width: px(60);
		height: px(60);
		display: flex;
		justify-content: center;
		align-items: center;
		@include breakpoint(m) {
			bottom: px(80);
			left: 0.7rem;
		}
	}

	.are-you-sure {
		border-radius: 20px;
		background: white;
		padding: 25px;
		text-align: center;
		.the-title {
			font-size: px(50);
		}
		.buttons {
			display: flex;
			justify-content: center;
			margin: px(15) 0;
			margin-bottom: px(50);
			gap: px(25);

			div {
				cursor: pointer;
				font-size: px(25);
				border-radius: 10px;
				height: 5px;
			}

			div:first-child {
				color: $mondadori-orange;
				box-shadow: 0 35px 0 0 $mondadori-orange;
			}
		
			div:last-child {
				color: $mondadori-green;
				box-shadow: 0 35px 0 0 $mondadori-green;
			}
		}
	}



</style>
